// utils/downloadPdf.js
export const downloadPdfFromBase64 = (base64Pdf, fileName = 'tms') => {
  if (!base64Pdf || typeof base64Pdf !== 'string') {
    console.error('No valid Base64 data provided for PDF download');
    return;
  }

  try {
    // Remove data URI prefix if present
    let base64String = base64Pdf.replace(/^data:application\/pdf;base64,/, '');

    // Validate Base64 string
    const isValidBase64 = /^[A-Za-z0-9+/=]+$/.test(base64String);
    if (!isValidBase64) {
      throw new Error('Invalid Base64 string: contains invalid characters');
    }

    // Ensure proper padding
    base64String = base64String.padEnd(base64String.length + (4 - (base64String.length % 4)) % 4, '=');

    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const pdfUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `${fileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(pdfUrl);
  } catch (error) {
    console.error('Failed to download PDF:', error);
    throw error; // Rethrow to allow caller to handle
  }
};